import Component from '../inherited/Component'

export default class LabelGenerator extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._fragrances = [
      {
        'name': 'Bergamot Incense',
        'amount': 'labelTopAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 0,
        'benzylbenzoate': 0.000836,
        'benzylcinnamate': 0.000038,
        'benzylalcohol': 0.000323,
        'cinnamylalcohol': 0,
        'citral': 0.130815,
        'citronellol': 0.000057,
        'coumarin': 0,
        'limonene': 1.540387,
        'eugenol': 0.000019,
        'farnesol': 0.000057,
        'geraniol': 0.003192,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0,
        'linalool': 0.325812,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0.2223,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Fig Neroli',
        'amount': 'labelTopAmount',
        'cinnamal': 0.000589,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 0,
        'benzylbenzoate': 0.003591,
        'benzylcinnamate': 0.041724,
        'benzylalcohol': 0.000285,
        'cinnamylalcohol': 0.001729,
        'citral': 0.038171,
        'citronellol': 0.000038,
        'coumarin': 0.015124,
        'limonene': 0.462935,
        'eugenol': 0.001463,
        'farnesol': 0.00057,
        'geraniol': 0.013452,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0,
        'linalool': 0.209228,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Cardamom Moss',
        'amount': 'labelTopAmount',
        'cinnamal': 0.0122,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 1.69782,
        'benzylbenzoate': 0.00226,
        'benzylcinnamate': 0.00002,
        'benzylalcohol': 0.00072,
        'cinnamylalcohol': 0.00004,
        'citral': 0.02124,
        'citronellol': 0.00224,
        'coumarin': 0.00002,
        'limonene': 0.45388,
        'eugenol': 0.00798,
        'farnesol': 0.00054,
        'geraniol': 0.02108,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0.00018,
        'linalool': 0.35802,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Jasmine Osmanthus',
        'amount': 'labelMidAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 3.07626,
        'benzylbenzoate': 0.004026,
        'benzylcinnamate': 0.000132,
        'benzylalcohol': 0.010846,
        'cinnamylalcohol': 0.00055,
        'citral': 0.00044,
        'citronellol': 0.161656,
        'coumarin': 0,
        'limonene': 0.000264,
        'eugenol': 0.087956,
        'farnesol': 0.000726,
        'geraniol': 0.185482,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0.000066,
        'linalool': 0.80597,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0.28,
        'butylmethoxydibenzoylmethane': 0.07,
        'diethylhexylsyringylidenemalonate': 0.05,
      },
      {
        'name': 'Rose Rhubarb',
        'amount': 'labelMidAmount',
        'cinnamal': 0.000018,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0.000018,
        'benzylsalicylate': 0.000018,
        'benzylbenzoate': 0.000018,
        'benzylcinnamate': 0.000018,
        'benzylalcohol': 0.000378,
        'cinnamylalcohol': 0.000018,
        'citral': 0.06561,
        'citronellol': 0.0054,
        'coumarin': 0.026874,
        'limonene': 0.526572,
        'eugenol': 0.00072,
        'farnesol': 0.000252,
        'geraniol': 0.00414,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0.000936,
        'isoeugenol': 0.000018,
        'linalool': 0.175644,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0.00009,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Tonka Sesame',
        'amount': 'labelMidAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 0.000088,
        'benzylbenzoate': 0.000022,
        'benzylcinnamate': 0,
        'benzylalcohol': 0.000066,
        'cinnamylalcohol': 0,
        'citral': 0,
        'citronellol': 0,
        'coumarin': 0.752136,
        'limonene': 0.000264,
        'eugenol': 0.00022,
        'farnesol': 0,
        'geraniol': 0,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0.000022,
        'linalool': 0.000022,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Sandalwood Musk',
        'amount': 'labelBaseAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 1.493091,
        'benzylbenzoate': 0.002116,
        'benzylcinnamate': 0,
        'benzylalcohol': 0.000529,
        'cinnamylalcohol': 0,
        'citral': 0,
        'citronellol': 0.000598,
        'coumarin': 0,
        'limonene': 0.136344,
        'eugenol': 0.000598,
        'farnesol': 0,
        'geraniol': 0,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0.000184,
        'hydroxycitronellal': 0,
        'isoeugenol': 0,
        'linalool': 0.009223,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Amber Iris',
        'amount': 'labelBaseAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0.00198,
        'benzylsalicylate': 0,
        'benzylbenzoate': 0.00078,
        'benzylcinnamate': 0.00002,
        'benzylalcohol': 0.00048,
        'cinnamylalcohol': 0,
        'citral': 0.00002,
        'citronellol': 0.00026,
        'coumarin': 0,
        'limonene': 0.05938,
        'eugenol': 0.00062,
        'farnesol': 0.00092,
        'geraniol': 0.0001,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0,
        'linalool': 0.00342,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 0,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      },
      {
        'name': 'Cedarwood Absinth',
        'amount': 'labelBaseAmount',
        'cinnamal': 0,
        'hexylcinnamal': 0,
        'amylcinnamylalcohol': 0,
        'amylcinnamal': 0,
        'anisylalcohol': 0,
        'benzylsalicylate': 0.000022,
        'benzylbenzoate': 0.00088,
        'benzylcinnamate': 0.000044,
        'benzylalcohol': 0.000242,
        'cinnamylalcohol': 0.000022,
        'citral': 0.000022,
        'citronellol': 0.000572,
        'coumarin': 0,
        'limonene': 0.097614,
        'eugenol': 0.001342,
        'farnesol': 0.016808,
        'geraniol': 0.001078,
        'hydroxyisohexyl3cyclohexenecarboxaldehyde': 0,
        'hydroxycitronellal': 0,
        'isoeugenol': 0.000022,
        'linalool': 0.024112,
        'methyl2octynoate': 0,
        'alphaisomethylionone': 2.178,
        'everniaprunastrioakmossextract': 0,
        'butylphenylmethylpropional': 0,
        'everniafurfuraceatreemossextract': 0,
        'ethylhexylsalicylate': 0,
        'butylmethoxydibenzoylmethane': 0,
        'diethylhexylsyringylidenemalonate': 0,
      }
    ];

    this._inputs = this._elem.querySelectorAll('input')
    this._selects = this._elem.querySelectorAll('select')
    this._allFields = this._elem.querySelectorAll('input, select')
  }

  mount () {
    for (let input of this._inputs) {
      input.addEventListener('input', () => {
        this.calculate()
      })
    }

    for (let input of this._selects) {
      input.addEventListener('change', () => {
        this.calculate()
      })
    }

    for (let input of this._allFields) {
      input.addEventListener('input', () => {
        let max = parseInt(this._elem.querySelector('#labelSize').value) || 0;
        let top = parseInt(this._elem.querySelector('#labelTopAmount').value) || 0;
        let mid = parseInt(this._elem.querySelector('#labelMidAmount').value) || 0;
        let base = parseInt(this._elem.querySelector('#labelBaseAmount').value) || 0;

        if ((top + mid + base) >= max) {
          if (input.id === 'labelTopAmount') {
            let newMax = max - (mid + base);
            this._elem.querySelector('#labelTopAmount').max = newMax;
            this._elem.querySelector('#labelTopAmount').value = newMax;
          } else if (input.id === 'labelMidAmount') {
            let newMax = max - (top + base);
            this._elem.querySelector('#labelMidAmount').max = newMax;
            this._elem.querySelector('#labelMidAmount').value = newMax;
          } else if (input.id === 'labelBaseAmount') {
            let newMax = max - (mid + top);
            this._elem.querySelector('#labelBaseAmount').max = newMax;
            this._elem.querySelector('#labelBaseAmount').value = newMax;
          }
        } else {
          this._elem.querySelector('#labelTopAmount').max = max;
          this._elem.querySelector('#labelMidAmount').max = max;
          this._elem.querySelector('#labelBaseAmount').max = max;
        }
      });
    }
  }

  calculate () {
    // Define variables
    let chosenFragrances = [];
    let cinnamal = 0;
    let hexylcinnamal = 0;
    let amylcinnamylalcohol = 0;
    let amylcinnamal = 0;
    let anisylalcohol = 0;
    let benzylsalicylate = 0;
    let benzylbenzoate = 0;
    let benzylcinnamate = 0;
    let benzylalcohol = 0;
    let cinnamylalcohol = 0;
    let citral = 0;
    let citronellol = 0;
    let coumarin = 0;
    let limonene = 0;
    let eugenol = 0;
    let farnesol = 0;
    let geraniol = 0;
    let hydroxyisohexyl3cyclohexenecarboxaldehyde = 0;
    let hydroxycitronellal = 0;
    let isoeugenol = 0;
    let linalool = 0;
    let methyl2octynoate = 0;
    let alphaisomethylionone = 0;
    let everniaprunastrioakmossextract = 0;
    let butylphenylmethylpropional = 0;
    let everniafurfuraceatreemossextract = 0;
    let ethylhexylsalicylate = 0;
    let butylmethoxydibenzoylmethane = 0;
    let diethylhexylsyringylidenemalonate = 0;
    let ingredientList = {};

    // Get selected options
    let divideBy = this._elem.querySelector('#labelSize').value;
    let topSelected = this._elem.querySelector('#labelTop').value;
    let midSelected = this._elem.querySelector('#labelMid').value;
    let baseSelected = this._elem.querySelector('#labelBase').value;
    let topAmount = this._elem.querySelector('#labelTopAmount').value;
    let midAmount = this._elem.querySelector('#labelMidAmount').value;
    let baseAmount = this._elem.querySelector('#labelBaseAmount').value;

    // Generate Selected Fragrance List
    let top = this._fragrances[topSelected];
    let mid = this._fragrances[midSelected];
    let base = this._fragrances[baseSelected];
    chosenFragrances.push(top, mid, base);

    chosenFragrances.forEach((fragrance) => {
      var amountValue = this._elem.querySelector('#' + fragrance.amount).value / divideBy;

      cinnamal += amountValue * fragrance.cinnamal;
      hexylcinnamal += amountValue * fragrance.hexylcinnamal;
      amylcinnamylalcohol += amountValue * fragrance.amylcinnamylalcohol;
      amylcinnamal += amountValue * fragrance.amylcinnamal;
      anisylalcohol += amountValue * fragrance.anisylalcohol;
      benzylsalicylate += amountValue * fragrance.benzylsalicylate;
      benzylbenzoate += amountValue * fragrance.benzylbenzoate;
      benzylcinnamate += amountValue * fragrance.benzylcinnamate;
      benzylalcohol += amountValue * fragrance.benzylalcohol;
      cinnamylalcohol += amountValue * fragrance.cinnamylalcohol;
      citral += amountValue * fragrance.citral;
      citronellol += amountValue * fragrance.citronellol;
      coumarin += amountValue * fragrance.coumarin;
      limonene += amountValue * fragrance.limonene;
      eugenol += amountValue * fragrance.eugenol;
      farnesol += amountValue * fragrance.farnesol;
      geraniol += amountValue * fragrance.geraniol;
      hydroxyisohexyl3cyclohexenecarboxaldehyde += amountValue * fragrance.hydroxyisohexyl3cyclohexenecarboxaldehyde;
      hydroxycitronellal += amountValue * fragrance.hydroxycitronellal;
      isoeugenol += amountValue * fragrance.isoeugenol;
      linalool += amountValue * fragrance.linalool;
      methyl2octynoate += amountValue * fragrance.methyl2octynoate;
      alphaisomethylionone += amountValue * fragrance.alphaisomethylionone;
      everniaprunastrioakmossextract += amountValue * fragrance.everniaprunastrioakmossextract;
      butylphenylmethylpropional += amountValue * fragrance.butylphenylmethylpropional;
      everniafurfuraceatreemossextract += amountValue * fragrance.everniafurfuraceatreemossextract;
      ethylhexylsalicylate += amountValue * fragrance.ethylhexylsalicylate;
      butylmethoxydibenzoylmethane += amountValue * fragrance.butylmethoxydibenzoylmethane;
      diethylhexylsyringylidenemalonate += amountValue * fragrance.diethylhexylsyringylidenemalonate;
    });

    // Generate Ingredient List
    ingredientList["Alcohol Denat."] = 99999;
    ingredientList["Parfum (Fragrance)"] = 9999;
    if( cinnamal > 0.00098 ) { ingredientList["Cinnamal"] = cinnamal; }
    if( hexylcinnamal > 0.00098 ) { ingredientList["Hexyl Cinnamal"] = hexylcinnamal; }
    if( amylcinnamylalcohol > 0.00098 ) { ingredientList["Amyl Cinnamyl Alcohol"] = amylcinnamylalcohol; }
    if( amylcinnamal > 0.00098 ) { ingredientList["Amyl Cinnamal"] = amylcinnamal; }
    if( anisylalcohol > 0.00098 ) { ingredientList["Anisyl Alcohol"] = anisylalcohol; }
    if( benzylsalicylate > 0.00098 ) { ingredientList["Benzyl Salicylate"] = benzylsalicylate; }
    if( benzylbenzoate > 0.00098 ) { ingredientList["Benzyl Benzoate"] = benzylbenzoate; }
    if( benzylcinnamate > 0.00098 ) { ingredientList["Benzyl Cinnamate"] = benzylcinnamate; }
    if( benzylalcohol > 0.00098 ) { ingredientList["Benzyl Alcohol"] = benzylalcohol; }
    if( cinnamylalcohol > 0.00098 ) { ingredientList["Cinnamyl Alcohol"] = cinnamylalcohol; }
    if( citral > 0.00098 ) { ingredientList["Citral"] = citral; }
    if( citronellol > 0.00098 ) { ingredientList["Citronellol"] = citronellol; }
    if( coumarin > 0.00098 ) { ingredientList["Coumarin"] = coumarin; }
    if( limonene > 0.00098 ) { ingredientList["Limonene"] = limonene; }
    if( eugenol > 0.00098 ) { ingredientList["Eugenol"] = eugenol; }
    if( farnesol > 0.00098 ) { ingredientList["Farnesol"] = farnesol; }
    if( geraniol > 0.00098 ) { ingredientList["Geraniol"] = geraniol; }
    if( hydroxyisohexyl3cyclohexenecarboxaldehyde > 0.00098 ) { ingredientList["Hydroxyisohexyl 3-cyclohexene carboxaldehyde"] = hydroxyisohexyl3cyclohexenecarboxaldehyde; }
    if( hydroxycitronellal > 0.00098 ) { ingredientList["Hydroxycitronellal"] = hydroxycitronellal; }
    if( isoeugenol > 0.00098 ) { ingredientList["Isoeugenol"] = isoeugenol; }
    if( linalool > 0.00098 ) { ingredientList["Linalool"] = linalool; }
    if( methyl2octynoate > 0.00098 ) { ingredientList["Methyl 2-Octynoate"] = methyl2octynoate; }
    if( alphaisomethylionone > 0.00098 ) { ingredientList["alpha-iso-Methylionone"] = alphaisomethylionone; }
    if( everniaprunastrioakmossextract > 0.00098 ) { ingredientList["Evernia Prunastri (Oakmoss) Extract"] = everniaprunastrioakmossextract; }
    if( butylphenylmethylpropional > 0.00098 ) { ingredientList["Butylphenyl Methylpropional"] = butylphenylmethylpropional; }
    if( everniafurfuraceatreemossextract > 0.00098 ) { ingredientList["Evernia Furfuracea (Treemoss) Extract"] = everniafurfuraceatreemossextract; }
    if( ethylhexylsalicylate > 0.00098 ) { ingredientList["Ethylhexyl Salicylate"] = ethylhexylsalicylate; }
    if( butylmethoxydibenzoylmethane > 0.00098 ) { ingredientList["Butyl Methoxydibenzoylmethane"] = butylmethoxydibenzoylmethane; }
    if( diethylhexylsyringylidenemalonate > 0.00098 ) { ingredientList["Diethylhexyl Syringylidenemalonate"] = diethylhexylsyringylidenemalonate; }

    const sortedList = Object.fromEntries(
      Object.entries(ingredientList).sort((a,b) => b[1]-a[1])
      );

    console.log(ingredientList);

    this._elem.querySelector('[data-label-generator-output]').value = Object.keys(sortedList).join(", ");
  }
}